import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SidebarLink = ({
  title, icon, newLink, route, onClick, changeSidebarVisibility
}) => {
  const handleClick = () => {
    onClick(title);
    changeSidebarVisibility(); // Call changeSidebarVisibility function
  };

  return (
    <NavLink
      to={route}
      onClick={handleClick} // Use handleClick instead of onClick directly
      activeClassName="sidebar__link-active"
    >
      <li className="sidebar__link">
        {icon ? <FontAwesomeIcon icon={icon} /> : ''}
        <p className="sidebar__link-title">
          {title}
          {newLink ? <Badge className="sidebar__link-badge"><span>New</span></Badge> : ''}
        </p>
      </li>
    </NavLink>
  );
};

SidebarLink.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.object, // Change PropTypes.string to PropTypes.object for icon
  newLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
  changeSidebarVisibility: PropTypes.func, // Add PropTypes for changeSidebarVisibility
};

SidebarLink.defaultProps = {
  icon: null, // Change default value to null for icon
  newLink: false,
  route: '/',
  onClick: () => {},
  changeSidebarVisibility: () => {}, // Default value for changeSidebarVisibility
};

export default SidebarLink;
